module.exports = __webpack_public_path__ + "img/link-arrow.7090d51d.svg";